import React from 'react';
import Icon from '@mdi/react';
import { mdiDomain, mdiAccount } from '@mdi/js';
import './OrgLoginContextModal.css';

/**
 * OrgLoginContextModal
 * Shown when a non-owner org admin logs in.
 * Lets them choose to log in as the organisation or as themselves.
 */
const OrgLoginContextModal = ({ orgs, onSelectOrg, onSelectPersonal, isLoading }) => {
    const singleOrg = orgs.length === 1 ? orgs[0] : null;

    return (
        <div className="org-context-modal-overlay">
            <div className="org-context-modal">
                {/* Header */}
                <div className="org-context-modal-header">
                    <Icon path={mdiDomain} size={1.2} color="var(--dl-color-purple-default)" />
                    <h2>Who are you logging in as?</h2>
                </div>

                {/* Body */}
                <div className="org-context-modal-body">
                    <p className="org-context-modal-subtitle">
                        You're assigned as an admin on{' '}
                        {singleOrg ? <strong>{singleOrg.name}</strong> : 'the following organisations'}.
                        {' '}Choose how you'd like to sign in:
                    </p>

                    {/* Org option(s) */}
                    {orgs.map(org => (
                        <button
                            key={org.orgId}
                            className="org-context-option org-context-option--org"
                            onClick={() => onSelectOrg(org.orgId)}
                            disabled={isLoading}
                        >
                            <Icon path={mdiDomain} size={1} color="var(--dl-color-purple-default)" />
                            <div className="org-context-option-text">
                                <span className="org-context-option-title">{org.name}</span>
                                <span className="org-context-option-subtitle">Sign in to this account</span>
                            </div>
                        </button>
                    ))}

                    {/* Personal option */}
                    <button
                        className="org-context-option org-context-option--personal"
                        onClick={onSelectPersonal}
                        disabled={isLoading}
                    >
                        <Icon path={mdiAccount} size={1} color="var(--dl-color-gray-600)" />
                        <div className="org-context-option-text">
                            <span className="org-context-option-title">My own account</span>
                            <span className="org-context-option-subtitle">Sign in as yourself</span>
                        </div>
                    </button>
                </div>

                {isLoading && (
                    <div className="org-context-modal-loading">Signing in...</div>
                )}
            </div>
        </div>
    );
};

export default OrgLoginContextModal;
